import useSWR from 'swr';
import * as service from './service';

const productsFetcher = (...products) =>
  Promise.all(products.map(service.get)).then(resps =>
    // pluck the data off all the API requests
    resps.map(resp => resp.data),
  );

export const useProductsList = products => {
  // https://github.com/vercel/swr/issues/1041
  const { data, error } = useSWR(products, productsFetcher);

  return {
    products: data,
    isLoading: !error && !data,
    error,
  };
};
